<template>
  <div class="company-settings-page w-full">
    <CompanySettings v-if="initialData" v-bind="initialData" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import CompanySettings from "@/CompanySettings/CompanySettings.vue";

const initialData = ref<{
  defaultTaxability: string;
  defaultTaxZoneId: number;
  tenantId: number;
  salesTaxRate: string;
  financeMarkup: string;
  defaultMembershipProgramId: number;
  defaultQuoteTypeId: string;
  quoteTypes: any[];
  timezones: any[];
  preWorkEnabled: boolean;
  arrivalWindowDurationSeconds: number;
  timeCardsEnabled: boolean;
  dailyOvertimeHours: number;
  dailyDoubleOvertimeHours: number;
  jobStatusEnabled: boolean;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
